<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Children’s/Family
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>Children's/Family events experienced a y-o-y decline in revenue by 27.0% (from $59.8m in 2018 to $43.6m in 2019) and a decline in attendance by 29.0% (from 1.7m in 2018 to 1.2m in 2019).</p>
          <p>The decline was partially offset by a 1.1% increase in the average ticket price (from $40.63 in 2018 to $41.08 in 2019). The revenue in this category was primarily driven by national tours of major events that attracted large audiences, including <em>Disney on Ice</em> and <em>The Wiggles</em>.</p>
          <p>Bans on mass gatherings, border closures and density limits introduced as part of COVID-19 restrictions resulted in a decline in revenue (by 76.2% to $10.4m) and a decline in attendance (by 67.7% to 0.4m) in 2020. Additionally, a decline in the average ticket price (by 26.2% to $30.33) further contributed to the decline in revenue. Top events in this category in 2020 were <em>The 91 Storey Treehouse</em>, <em>Bluey’s Big Play</em>, <em>The Midnight Gang</em> and <em>Operation Ouch</em>.</p>
          <p>In 2019, NSW and Victoria generated the most revenue and attendance in this category, with a national market share of approximately 31.5% and 30.1% respectively in revenue and 31.5% and 28.2% respectively in attendance.</p>
        </div>
        <div class="sixcol last">
          <p>In 2020, NSW and QLD generated the most revenue and attendance in this category, with a national market share of approximately 27.7% and 19.6% respectively in revenue and 34.9% and 16.2% respectively in attendance.</p>
          <p>In 2019, all states showed a y-o-y decline in revenue except ACT and all states except ACT and QLD showed a y-o-y decline in attendance. ACT experienced the most significant y-o-y growth in revenue (62.3%) and attendance (27.1%), driven by major performances such as <em>Disney On Ice</em>, <em>The Wiggles</em> and <em>Deadly 60 Down Under</em>.</p>
          <p>In 2020, all states showed a y-o-y decline in revenue and attendance except TAS. TAS experienced the most significant y-o-y growth in revenue (506.0%) and attendance (148.3%) in this category, driven by major performances such as <em>Operation Ouch Live!</em>, <em>The Wiggles</em> and <em>Sesame Street Circus</em>, which were all presented prior to COVID-19 restrictions.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="children-family-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <ul class="switches">
          <li><a href="javascript:;" :class="{active: activeYear==2019}"
            @click="activeYear=2019">2019</a></li>
          <li><a href="javascript:;" :class="{active: activeYear==2020}"
            @click="activeYear=2020">2020</a></li>
        </ul>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
        </div>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>Bluey's Big Play</em>, BBC Studios, Andrew Kay in association with Queensland Performing Arts Centre and Windmill Theatre Company, Photo Credit: Darren Thomas</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter () {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 120,
          verticalAlign: 'top',
          y: 100,
          floating: true,
          backgroundColor: '#fff'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [10.738, 43.109, 30.944, 46.535, 45.647, 31.905, 31.248, 58.777, 51.587, 38.684, 43.432, 38.368, 54.316, 51.308, 59.778, 43.649, 10.397],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.515, 1.271, 1.114, 1.394, 1.455, 1.076, 0.975, 1.453, 1.3, 1.091, 1.214, 1.081, 1.376, 1.306, 1.651, 1.172, 0.378],
          color: '#d14967'
        }]
      },
      activeYear: 2019,
      stateBreakdowns: [
        {
          year: 2019,
          revenue: [
            ["NSW", 31.5],
            ["VIC", 30.1],
            ["QLD", 15.0],
            ["WA", 10.2],
            ["SA", 6.6],
            ["ACT", 5.5],
            ["TAS", 0.6],
            ["NT", 0.5]
          ],
          attendance: [
            ["NSW", 31.5],
            ["VIC", 28.2],
            ["QLD", 15.7],
            ["WA", 10.9],
            ["SA", 6.6],
            ["ACT", 5.1],
            ["TAS", 1.3],
            ["NT", 0.7]
          ]
        },
        {
          year: 2020,
          revenue: [
            ["NSW", 27.7],
            ["VIC", 15.9],
            ["QLD", 19.6],
            ["WA", 12.3],
            ["SA", 4.9],
            ["ACT", 3.8],
            ["TAS", 14.2],
            ["NT", 1.6]
          ],
          attendance: [
            ["NSW", 34.9],
            ["VIC", 13.4],
            ["QLD", 16.2],
            ["WA", 12.0],
            ["SA", 7.6],
            ["ACT", 3.8],
            ["TAS", 10.1],
            ["NT", 1.9]
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [{
              name: 'Revenue Share',
              data: stateBreakdown.revenue,
              size: '68%',
              innerSize: '40%',
              borderColor: 'none',
              borderWidth: 1,
              slicedOffset: 30,
              showInLegend: true,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              }
            }, {
              name: 'Attendance Share',
              data: stateBreakdown.attendance,
              size: '100%',
              innerSize: '70%',
              borderColor: 'transparent',
              borderWidth: 1,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -32
              }
            }],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url(~@/assets/img/2019/Bluey%27s-Big-Play%2C-BBC-Studios%2C-Andrew-Kay-in-association-with-Queensland-Performing-Arts-Centre-and-Windmill-Theatre-Company%2C-Photo-Credit-Darren-Thomas_SFW.jpg);
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
